(() => {
  const theme = window.theme || {};
  const root = (theme.routes && theme.routes.root) || '/';
  const routes = Object.assign(
    { cartAdd: root + 'cart/add.js', cart: root + 'cart.js', cartChange: root + 'cart/change.js', cartPage: root + 'cart', checkout: root + 'checkout' },
    theme.routes || {}
  );

  document.documentElement.classList.remove('no-js');

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = theme.moneyFormat || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    const withDelims = (n, decimals, thousands, decimal) => {
      const [whole, frac] = n.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  theme.formatMoney = formatMoney;

  const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Buy box ---------- */
  document.querySelectorAll('[data-buybox]').forEach((box) => {
    const dataEl = box.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = box.querySelector('form');
    const idInput = form.querySelector('[name="id"]');
    const planInput = form.querySelector('[name="selling_plan"]');
    const priceEl = box.querySelector('[data-price]');
    const compareEl = box.querySelector('[data-compare-price]');
    const saveEl = box.querySelector('[data-save]');
    const perServingEl = box.querySelector('[data-per-serving]');
    const submit = form.querySelector('[type="submit"]');
    const submitLabel = submit.querySelector('.btn__label');
    const errorEl = box.querySelector('[data-error]');
    const selectedLabel = box.querySelector('[data-selected-label]');
    const servings = Number(box.dataset.servings) || 0;

    const currentVariant = () => product.variants.find((v) => String(v.id) === String(idInput.value)) || product.variants[0];
    const currentPlan = () => (planInput && planInput.value ? planInput.value : null);

    function update() {
      const v = currentVariant();
      let price = v.price;
      let compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
      const planId = currentPlan();
      if (planId && v.selling_plan_allocations) {
        const alloc = v.selling_plan_allocations.find((a) => String(a.selling_plan_id) === String(planId));
        if (alloc) { price = alloc.price; compare = alloc.compare_at_price > alloc.price ? alloc.compare_at_price : compare; }
      }
      // Quantity bundles (single product sold as 1/2/3 jars, savings from automatic discounts)
      const bundle = box.querySelector('[data-qty-radio]:checked');
      let units = Math.max(1, parseInt(v.title, 10) || 1);
      if (bundle) {
        units = Number(bundle.value);
        price = Number(bundle.dataset.price);
        compare = Number(bundle.dataset.compare) > price ? Number(bundle.dataset.compare) : null;
        const qtyInput = box.querySelector('[data-bundle-qty]');
        if (qtyInput) qtyInput.value = bundle.value;
      }
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (compareEl) { compareEl.textContent = compare ? formatMoney(compare) : ''; compareEl.hidden = !compare; }
      if (saveEl) {
        saveEl.hidden = !compare;
        if (compare) saveEl.textContent = (theme.strings.save || 'Save') + ' ' + Math.round(((compare - price) / compare) * 100) + '%';
      }
      if (perServingEl && servings) {
        // Bundle variants start with their unit count, e.g. "2 Jars"; quantity bundles set units above
        perServingEl.textContent = formatMoney(Math.round(price / (servings * units))) + ' ' + (theme.strings.perServing || 'per serving');
      }
      if (selectedLabel) selectedLabel.textContent = bundle ? bundle.dataset.label : v.title === 'Default Title' ? '' : v.title;
      submit.disabled = !v.available;
      submitLabel.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;
      document.querySelectorAll('[data-sticky-price]').forEach((el) => (el.textContent = formatMoney(price)));
      if (box.dataset.updateUrl === 'true' && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.featured_media) box.dispatchEvent(new CustomEvent('variant:media', { bubbles: true, detail: { mediaId: v.featured_media.id } }));
    }

    box.querySelectorAll('[data-variant-radio]').forEach((r) => r.addEventListener('change', () => { idInput.value = r.value; update(); }));
    box.querySelectorAll('[data-qty-radio]').forEach((r) => r.addEventListener('change', update));
    box.querySelectorAll('[data-plan-radio]').forEach((r) => r.addEventListener('change', () => { planInput.value = r.value; update(); }));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl && errorEl.classList.remove('is-visible');
      submit.classList.add('is-loading');
      try {
        const res = await fetch(routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        await Cart.open();
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.classList.add('is-visible'); }
      } finally {
        submit.classList.remove('is-loading');
      }
    });

    update();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn || btn.closest('[data-line]')) return;
    const input = btn.parentElement.querySelector('input');
    const next = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(btn.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const slides = [...g.querySelectorAll('[data-slide]')];
    const thumbs = [...g.querySelectorAll('[data-thumb]')];
    const show = (i) => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      // Stat chips would cover the lifestyle photo, so they only show on product shots
      g.classList.toggle('is-lifestyle', slides[i].hasAttribute('data-lifestyle'));
      thumbs.forEach((t, n) => { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i); });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    document.addEventListener('variant:media', (e) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(e.detail.mediaId));
      if (i > -1) show(i);
    });
  });

  /* ---------- Cart drawer ---------- */
  const Cart = {
    el: document.querySelector('[data-cart-drawer]'),
    async fetch() {
      const res = await fetch(routes.cart, { headers: { Accept: 'application/json' } });
      return res.json();
    },
    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
    },
    render(cart) {
      this.updateCount(cart.item_count);
      if (!this.el) return;
      const body = this.el.querySelector('[data-cart-body]');
      const foot = this.el.querySelector('[data-cart-foot]');
      const threshold = Number(this.el.dataset.freeShipping) * 100 * (Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
      let progress = '';
      if (threshold > 0 && cart.item_count > 0) {
        const remaining = threshold - cart.total_price;
        const pct = Math.min(100, (cart.total_price / threshold) * 100);
        // One product sold by the jar: point single-jar carts at the 2-jar bundle instead of an odd dollar amount
        const singleLine = cart.items.length === 1 && theme.strings.freeShippingAddJar;
        const message = remaining <= 0
          ? theme.strings.freeShippingUnlocked
          : singleLine ? escapeHtml(theme.strings.freeShippingAddJar) : theme.strings.freeShippingRemaining.replace('[amount]', '<b>' + formatMoney(remaining) + '</b>');
        const addJar = remaining > 0 && singleLine
          ? `<button type="button" class="ship-progress__add" data-line-add="${escapeHtml(cart.items[0].key)}" data-qty="${cart.items[0].quantity + 1}">${escapeHtml(theme.strings.addJar)}</button>`
          : '';
        progress = `<div class="ship-progress ${remaining <= 0 ? 'is-complete' : ''}">${message}<div class="ship-progress__bar"><div class="ship-progress__fill" style="width:${pct}%"></div></div>${addJar}</div>`;
      }
      if (!cart.item_count) {
        body.innerHTML = `<div class="cart-empty"><p>${escapeHtml(theme.strings.cartEmpty)}</p><button type="button" class="btn" data-cart-close><span class="btn__label">${escapeHtml(theme.strings.shopNow)}</span></button></div>`;
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      body.innerHTML = progress + cart.items.map((item) => `
        <div class="line-item" data-line="${escapeHtml(item.key)}">
          <div class="line-item__img">${item.image ? `<img src="${escapeHtml(item.image + (item.image.includes('?') ? '&' : '?') + 'width=160')}" alt="" width="76" height="76" loading="lazy">` : `<img class="logo-icon" src="${escapeHtml(theme.assets.logoIcon)}" alt="">`}</div>
          <div>
            <div class="line-item__title">${escapeHtml(item.product_title)}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="line-item__variant">${escapeHtml(item.variant_title)}</div>` : ''}
            ${item.selling_plan_allocation ? `<div class="line-item__variant">${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</div>` : ''}
            <div class="line-item__controls">
              <div class="qty"><button type="button" data-line-step="-1" aria-label="${escapeHtml(theme.strings.decrease)}">−</button><input type="number" value="${item.quantity}" min="0" aria-label="${escapeHtml(theme.strings.quantity)}" data-line-qty><button type="button" data-line-step="1" aria-label="${escapeHtml(theme.strings.increase)}">+</button></div>
              <button type="button" class="line-item__remove" data-line-remove>${escapeHtml(theme.strings.remove)}</button>
            </div>
          </div>
          <div class="line-item__price">${formatMoney(item.final_line_price)}${item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : ''}</div>
        </div>`).join('');
      // Bundle savings are cart-level discounts, so the line keeps its full price; show the saving above the subtotal.
      // cart/change.js omits the discount list, so derive it from the totals both endpoints return.
      const saved = (cart.original_total_price || 0) - cart.total_price;
      this.el.querySelector('[data-cart-discounts]').innerHTML = saved > 0
        ? `<div class="cart-discounts__row"><span>${escapeHtml(theme.strings.bundleSavings)}</span><span>−${formatMoney(saved)}</span></div>`
        : '';
      this.el.querySelector('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);
    },
    async change(key, quantity) {
      this.el && this.el.classList.add('is-busy');
      const res = await fetch(routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const cart = await res.json();
      this.el && this.el.classList.remove('is-busy');
      this.render(cart);
    },
    async open() {
      const cart = await this.fetch();
      this.render(cart);
      if (!this.el) { window.location.href = routes.cartPage; return; }
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      this.el.querySelector('.drawer__close').focus();
    },
    close() {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    },
  };
  theme.cart = Cart;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
    const addJar = e.target.closest('[data-line-add]');
    if (addJar) { Cart.change(addJar.dataset.lineAdd, Number(addJar.dataset.qty)); return; }
    const line = e.target.closest('[data-line]');
    if (!line || !line.closest('[data-cart-drawer]')) return;
    const input = line.querySelector('[data-line-qty]');
    const step = e.target.closest('[data-line-step]');
    if (step) Cart.change(line.dataset.line, Math.max(0, Number(input.value) + Number(step.dataset.lineStep)));
    if (e.target.closest('[data-line-remove]')) Cart.change(line.dataset.line, 0);
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-line-qty]')) return;
    const line = e.target.closest('[data-line]');
    if (line && line.closest('[data-cart-drawer]')) Cart.change(line.dataset.line, Math.max(0, Number(e.target.value) || 0));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') Cart.close(); });

  /* ---------- Sticky add to cart ---------- */
  const sticky = document.querySelector('[data-sticky-atc]');
  const mainAtc = document.querySelector('[data-buybox] [type="submit"]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      // Show whenever the main button is off screen, so phone shoppers can always add to cart
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }).observe(mainAtc);
    sticky.querySelector('button').addEventListener('click', () => {
      if (mainAtc.disabled) return;
      mainAtc.closest('form').requestSubmit();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }
})();

/* ---------- Mobile menu ---------- */
(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;
  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    menu.hidden = !open;
  };
  toggle.addEventListener('click', () => setOpen(menu.hidden));
  menu.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  window.addEventListener('resize', () => { if (window.innerWidth > 1080) setOpen(false); });
})();
